import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import RegionJson from "@/assets/json/region.json";
import axios from "axios";
import { mapGetters } from "vuex";
import store from "@/store";
import moment from "moment";

export default {
    name: "ApplyIndex",
    components: {
        MainLayout
    },

    data() {
        return {
            jobInfo: {
                id: "",
                path: "",
                company_name: "",
                job_title: "",
                job_type: "",
                city: "",
                township: "",
                address: "",
                min_salary: "",
                max_salary: "",
                category_name: "",
                description: "",
                gender: "",
                experience: "",
                qualification: "",
                education: "",
                expired_date: "",
                posted_date: ""
            },
            resumeList: {},
            applyForm: {
                resume_id: "",
            },
            regionArr: RegionJson
        };
    },

    methods: {
        getJobDetail() {
            if (!this.$route.params.id || this.$route.params.id === 'undefined') {
                this.$router.push({ name: "notFound" });
                return;
            }
            axios.get("/job/detail/" + this.$route.params.id)
                .then(response => {
                    if (!response.data || !response.data.id || response.data.is_expired) {
                        this.$router.push({ name: "notFound" });
                        return;
                    }
                    this.jobInfo = response.data;
                })
                .catch(error => {
                    console.log(error);
                    this.$router.push({ name: "notFound" });
                });
        },

        getResume() {
            axios.get("/applicant/resume/list/" + this.applicantId)
                .then(response => {
                    this.resumeList = response.data;
                })
                .catch(error => {
                    console.log("Resume List API error:::::>", error.response.data);
                });
        },

        createApply() {
            var request = {
                resume_id: this.applyForm.resume_id,
                job_id: this.jobInfo.id,
                applicant_id: this.applicantId,
            };
            axios.post("/apply/create", request)
                .then(response => {
                    if (response.data.apply) {
                        this.$notification.success(response.data.message, {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                    } else {
                        this.$notification.warning(response.data.message, {
                            timer: 3,
                            position: 'bottomCenter'
                        });
                    }
                })
                .catch(error => {
                    this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    console.log('Apply Create API Error', error);
                });
        },

        downloadResumePdf(id) {
            axios({
                url: axios.defaults.baseURL + "applicant/resume/download/" + id,
                method: "GET",
                responseType: "blob"
            })
                .then((response) => {
                    var today = new Date();
                    var date = today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate();
                    var cvName = this.applicantName + '_' + id + '_' + date + '_CV.pdf';
                    var url = window.URL.createObjectURL(new Blob([response.data]));
                    var link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', cvName);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log("Resume Download API error:::::>", error.response);
                });
        },

        getResumeCount() {
            axios.get("/applicant/resume/count/" + this.applicantId)
                .then(response => {
                    this.resumeCount = response.data.count;
                    store.commit("setResumeCount", this.resumeCount);
                })
                .catch(error => {
                    console.log("Resume Count API error:::::>", error.response.data);
                });
        },

        goResumeRegister() {
            if (!this.isApplicantLoggedIn) {
                this.$router.push({ name: 'applicantLogin' });
                return;
            }
            if (this.resumeCountNo < 3) {
                this.$router.push('/resume', () => { });
            } else {
                this.$notification.error("အလုပ်လျှောက်လွှာအများဆုံး ၃ ခုသာ ပြုလုပ်ခွင့်ပြုသည်။", { timer: 3, position: 'bottomCenter' });
            }
        },

        getJobType(job_type) {
            if (job_type == '1') {
                this.job_type = 'Full-time';
            } else if (job_type == '2') {
                this.job_type = 'Part-time';
            } else if (job_type == '3') {
                this.job_type = 'Internship';
            } else if (job_type == '4') {
                this.job_type = 'Freelance';
            } else if (job_type == '5') {
                this.job_type = 'Remote Job';
            } else {
                this.job_type = 'သတ်မှတ်ထားခြင်းမရှိပါ';
            }
            return this.job_type;
        },

        formatRowNo(index) {
            const num = index + 1;
            return num >= 10 ? num.toString() : '0' + num;
        },

        formatNumber(value) {
            return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
    },

    mounted() {
        if (this.applicantId) {
            this.getResumeCount();
        }
        this.getJobDetail();
        this.getResume();
    },
    computed: {
        isDisabled: function () {
            return !this.applyForm.resume_id;
        },

        ...mapGetters({ applicantId: "applicantId", applicantName: "applicantName", isApplicantLoggedIn: "isApplicantLoggedIn", resumeCountNo: "resumeCountNo" })
    },
    filters: {
        setMoment: function (value) {
            return moment(value).format("YYYY-MM-DD");
        }
    }
};
